export default "__VITE_ASSET__HiCGCZaC__"